import {useState} from 'react'
import Swal from 'sweetalert2'
import {useAuth} from '../core/Auth'
import {leaveImpersonation} from '../core/_requests'

// Aviso fixo exibido enquanto um admin navega como outro usuário ("logar com usuário")
const ImpersonationBanner = () => {
  const {currentUser} = useAuth()
  const [leaving, setLeaving] = useState(false)

  if (!currentUser?.impersonatedBy) return null

  const handleLeave = async () => {
    setLeaving(true)
    try {
      await leaveImpersonation()
      // Recarrega a aplicação para restaurar o usuário admin
      window.location.href = '/admin/users'
    } catch (error: any) {
      setLeaving(false)
      await Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error?.response?.data?.message ?? 'Não foi possível voltar ao admin.',
      })
    }
  }

  return (
    <div
      className='position-fixed bottom-0 start-50 translate-middle-x mb-5 px-6 py-3 rounded bg-dark text-white shadow d-flex align-items-center gap-4'
      style={{zIndex: 1100}}
    >
      <span>
        Você está logado como <b>{currentUser.name}</b> (admin: {currentUser.impersonatedBy.name})
      </span>
      <button
        type='button'
        className='btn btn-sm btn-danger'
        disabled={leaving}
        onClick={handleLeave}
      >
        {leaving ? 'Voltando...' : 'Voltar ao admin'}
      </button>
    </div>
  )
}

export {ImpersonationBanner}
